import './App.css';
//import { useState, useEffect } from 'react';
//import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Website from './website/website';

function App() {

  const screenWidth = window.innerWidth;

    const mobileScreen = {
        '--mobile-screen-size': screenWidth
    } 

  return (
    <div className="web-app-container" style={mobileScreen}>
      <Website/>
    </div>
  );
}

export default App;
